import Cookies from 'js-cookie';

const TokenKey = 'vue_admin_template_token';
const RememberMeKey = 'vue_admin_template_rememberMe';
const LanguageKey = 'vue_admin_template_language';

export const getToken = () => Cookies.get(TokenKey);

export const setToken = (token: string) => Cookies.set(TokenKey, token);

export const removeToken = () => Cookies.remove(TokenKey);

export const getRememberMe = () => Cookies.get(RememberMeKey);

export const setRememberMe = (rememberMe: string) => Cookies.set(RememberMeKey, rememberMe);

export const removeRememberMe = () => Cookies.remove(RememberMeKey);

export const setLanguage = (language: string) => Cookies.set(LanguageKey, language);

export const getLanguage = () => Cookies.get(LanguageKey);

export const removeLanguage = () => Cookies.remove(LanguageKey);
